<template>
    <InfoTooltip v-if="text" :text="text"/>
</template>

<script>
import InfoTooltip from "@/components/info-tooltip/InfoTooltip.vue";
export default {
    props: ["type"],
    data() {
        return {
            text: "" 
        };
    },
    components: {
        InfoTooltip
    },
    mounted() {
        switch (this.type) {
            case 'mtd':
                this.text = "Mês até a data";
                break;

            case 'qtd':
                this.text = "Trimestre até a data";
                break;
        
            default:
                this.text = "";
                break;
        }
    },
    filters: {},
    methods: {},
    computed: {},
};
</script>
